// Norwegian translations
export const noTranslations = {
  common: {
    // Hero section
    "hero.title": "Ta kontroll over kontraktene dine",
    "hero.subtitle": "Forenkle kontraktsadministrasjon med vår kraftige løsning. Få full oversikt, reduser kostnader og gå aldri glipp av en utløpsdato.",
    "hero.companyTitle": "Enkel håndtering av avtaler",
    "hero.companySubtitle": "for små og store bedrifter.",
    "hero.pricing": "Enkel og transparent prismodell. Subtrackr er alltid gratis!",
    "hero.benefit1": "Få full kontroll over dine avtaler uten kostnad.",
    "hero.benefit2": "Ingen kortinformasjon kreves.",
    "hero.getStarted": "Kom i gang",
    "hero.learnMore": "Lær mer",
    "hero.neverMiss": "Gå aldri glipp av en utløpsdato",

    // Features section
    "features.title": "Ta kontroll over kontraktene dine",
    "features.subtitle": "Vår plattform gir deg alt du trenger for å administrere kontrakter effektivt",
    
    "features.contractManagement.title": "Kontraktsadministrasjon",
    "features.contractManagement.description": "Lagre og organiser alle kontraktene dine på ett sikkert sted med enkel søk og filtrering",
    
    "features.reminders.title": "Smarte påminnelser",
    "features.reminders.description": "Få varsler om fornyelser og oppsigelsesfrister for å unngå uønskede automatiske fornyelser",
    
    "features.dashboards.title": "Kraftige dashbord",
    "features.dashboards.description": "Få innsikt med visuelle dashbord som viser kontraktsstatus, utgifter og kommende fornyelser",
    
    "features.compliance.title": "Compliance-sporing",
    "features.compliance.description": "Hold oversikt over compliance-krav og sørg for at virksomheten din overholder forskrifter",
    
    "features.notifications.title": "Tilpassede varsler",
    "features.notifications.description": "Konfigurer varslingsplaner for teamet ditt basert på kontraktshendelser og milepæler",
    
    "features.collaboration.title": "Teamsamarbeid",
    "features.collaboration.description": "Del kontrakter med teammedlemmer og tildel roller og ansvar",

    // Testimonials section
    "testimonials.title": "Brukt av virksomheter over hele Norge",
    "testimonials.subtitle": "Se hva kundene våre sier om Subtrackr",
    
    "testimonials.quote1": "Subtrackr har forvandlet hvordan vi administrerer kontrakter. Vi har kuttet kostnadene med 15 % ved å fange automatiske fornyelser vi ville ha gått glipp av før.",
    "testimonials.author1": "Maria Johansen",
    "testimonials.role1": "Operasjonsdirektør",
    "testimonials.company1": "Nordic Solutions AS",
    
    "testimonials.quote2": "Dashbordet gir oss en komplett oversikt over alle kontrakter på tvers av avdelinger. Enkelt å bruke og utrolig effektivt.",
    "testimonials.author2": "Thomas Berg",
    "testimonials.role2": "Økonomidirektør",
    "testimonials.company2": "Fjord Technology",
    
    "testimonials.quote3": "Vi har redusert tiden brukt på kontraktsadministrasjon med 70 %. Påminnelsene alene er verdt investeringen.",
    "testimonials.author3": "Lisa Andersen",
    "testimonials.role3": "Juridisk rådgiver",
    "testimonials.company3": "Greenscape Energy",
    
    // Pricing section
    "pricing.title": "Enkel, transparent prising",
    "pricing.subtitle": "Velg en plan som passer dine behov",
    "pricing.perMonth": "/måned",
    "pricing.mostPopular": "Mest populær",
    "pricing.question": "Trenger du en tilpasset løsning for din virksomhet?",
    "pricing.contactUs": "Kontakt oss",
    
    "pricing.starter.name": "Starter",
    "pricing.starter.price": "999 kr",
    "pricing.starter.description": "Perfekt for små bedrifter",
    "pricing.starter.feature1": "Opptil 50 kontrakter",
    "pricing.starter.feature2": "E-postvarsler",
    "pricing.starter.feature3": "Grunnleggende rapportering",
    "pricing.starter.feature4": "24/7 support",
    "pricing.starter.button": "Kom i gang",
    
    "pricing.professional.name": "Professional",
    "pricing.professional.price": "1 999 kr",
    "pricing.professional.description": "Ideell for voksende bedrifter",
    "pricing.professional.feature1": "Ubegrenset antall kontrakter",
    "pricing.professional.feature2": "Avanserte dashbord",
    "pricing.professional.feature3": "Teamsamarbeid",
    "pricing.professional.feature4": "Tilpassede varsler",
    "pricing.professional.feature5": "Prioritert support",
    "pricing.professional.button": "Start gratis prøveperiode",
    
    "pricing.enterprise.name": "Enterprise",
    "pricing.enterprise.price": "3 999 kr",
    "pricing.enterprise.description": "For store organisasjoner",
    "pricing.enterprise.feature1": "Ubegrenset alt",
    "pricing.enterprise.feature2": "Tilpassede integrasjoner",
    "pricing.enterprise.feature3": "Dedikert kontaktperson",
    "pricing.enterprise.feature4": "SLA-garantier",
    "pricing.enterprise.feature5": "Avanserte sikkerhetsfunksjoner",
    "pricing.enterprise.feature6": "On-premises alternativ",
    "pricing.enterprise.button": "Kontakt salg",
    
    // CTA section
    "cta.title": "Klar til å transformere kontraktsadministrasjonen din?",
    "cta.subtitle": "Bli med hundrevis av fornøyde kunder som har forenklet kontraktsadministrasjonen sin med Subtrackr",
    "cta.getStarted": "Kom i gang nå",
    "cta.contactSales": "Kontakt salg",
    
    // Footer
    "footer.description": "Subtrackr hjelper bedrifter med å ta kontroll over kontraktene sine med kraftige administrasjonsverktøy, påminnelser og analyser.",
    "footer.product": "Produkt",
    "footer.features": "Funksjoner",
    "footer.pricing": "Priser",
    "footer.security": "Sikkerhet",
    "footer.company": "Selskap",
    "footer.about": "Om oss",
    "footer.contact": "Kontakt",
    "footer.privacy": "Personvernpolicy",
    "footer.terms": "Brukervilkår",
    "footer.copyright": "© {{year}} Subtrackr. Alle rettigheter reservert.",
    
    // Navigation
    "goToDashboard": "Gå til dashboard",
    "login": "Logg inn",
    "signup": "Registrer deg"
  },

  contractTypes: {
    subscription: {
      name: "Abonnement",
      description: "En gjentakende kontrakt med regelmessige betalinger"
    },
    serviceAgreement: {
      name: "Tjenesteavtale",
      description: "Kontrakt for levering av tjenester"
    },
    license: {
      name: "Lisensavtale",
      description: "Kontrakt for bruk av immaterielle rettigheter"
    },
    onetime: {
      name: "Engangskjøp",
      description: "Enkelt kjøp uten fornyelse"
    },
    lease: {
      name: "Leie/Utleie",
      description: "Kontrakt for leie av eiendom eller utstyr"
    },
    sales: {
      name: "Salgskontrakt",
      description: "Kontrakt for salg av produkter eller tjenester"
    },
    employment: {
      name: "Arbeidskontrakt",
      description: "Kontrakt med ansatte"
    },
    intro: "Kontraktstyper hjelper deg å kategorisere avtalene dine og anvende konsistente regler. Hver type kan ha spesifikke innstillinger for fornyelse og retning/formål.",
    empty: "Du har ingen kontraktstyper ennå. Legg til standardtyper eller opprett dine egne.",
    addingDefaults: "Legger til standarder...",
    addDefaults: "Legg til Standard Kontraktstyper",
    createManually: "Opprett Type Manuelt",
    yourTypes: "Dine Kontraktstyper",
    count: "Du har {{count}} kontrakttype(r)"
  },

  categories: {
    software: {
      name: "Programvare",
      description: "Programvarelisenser og abonnementer"
    },
    hardware: {
      name: "Maskinvare",
      description: "Fysisk maskinvare og utstyr"
    },
    services: {
      name: "Tjenester",
      description: "Profesjonelle og konsulenttjenester"
    },
    utilities: {
      name: "Forsyninger",
      description: "Forsyninger som elektrisitet, vann osv."
    },
    rent: {
      name: "Leie",
      description: "Kontor- og arbeidsplassleie"
    },
    intro: "Kategorier hjelper deg å organisere kontraktene dine og filtrere dem mer effektivt. Legg til kategorier som passer din organisasjons behov.",
    noCategories: "Ingen Kategorier Ennå",
    empty: "Du har ikke opprettet noen kategorier ennå. Legg til noen for å hjelpe med å organisere kontraktene dine.",
    addDefaults: "Legg til Standardkategorier",
    createCustom: "Opprett Tilpasset Kategori"
  }
};
